
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMosfetNtype1 as ObiMosfetNtype1Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-mosfet-ntype-1.js';
 
 
 

 
 export const ObiMosfetNtype1 = createComponent({
   react: React,
   tagName: 'obi-mosfet-ntype-1',
   elementClass: ObiMosfetNtype1Element,
   events: {
     
   }
  });
 
 